<template>
  <div class="cart-grouped" v-bind:class="{ 'is-loading': loadingMain }">
    <div class="scroll-container" ref="scroll">
      <button type="button" class="cart-grouped-close" @click="onClose" ref="closeBtn">
        <i class="ico ico-cross"></i>
        <span class="hide-access">{{ Translator('front.cart.add.close') }}</span>
      </button>
      <h1 class="cart-grouped-title">{{ Translator('front.cart.grouped.title') }}</h1>
      <div class="cart-instructions" :class="{'is-open': isShowInstructions}">
        <div class="cart-instructions-header">
          <h2 class="cart-instructions-title">{{ Translator('front.cart.grouped.instructions.title') }}</h2>
          <button type="button" class="cart-instructions-toggle" @click="isShowInstructions = !isShowInstructions">
            <template v-if="isShowInstructions">{{ Translator('front.cart.grouped.instructions.show_button') }}</template>
            <template v-if="!isShowInstructions">{{ Translator('front.cart.grouped.instructions.hide_button') }}</template>
            <i class="ico ico-chevron-bottom-medium"></i>
          </button>
        </div>
        <div class="cart-instructions-content" v-if="!isShowInstructions">
          <p class="cart-instructions-description" v-html="Translator('front.cart.grouped.instructions.description')"></p>
          <h3 class="cart-instructions-subtitle">{{ Translator('front.cart.grouped.instructions.legend_title') }}</h3>
          <div class="cart-instructions-legend" v-html="Translator('front.cart.grouped.instructions.legend_details')"></div>
        </div>
      </div>
      <div class="cart-grouped-loader" v-if="loadingMain"></div>
      <form class="std-form" v-if="games" novalidate @submit.prevent="" @submit="onSubmit">
        <h2 class="cart-grouped-subtitle">{{ Translator('front.cart.grouped.cards') }}</h2>

        <div class="cart-grouped-list">
          <div v-for="item, index in items" :key="item.keyIndex" class="cart-grouped-item">
            <CartGroupedItem :form="formV$" :formDatas="item" :index="index" :games="games" />
            <div class="cart-grouped-item-actions">
              <button type="button" class="cart-grouped-action" @click="onDupplicateItem(index)" v-if="isValidItem( item )">
                <i class="ico ico-copy"></i>
                <span class="cart-grouped-action-label">{{ Translator('front.cart.grouped.dupplicate') }}</span>
              </button>
              <button type="button" class="cart-grouped-action" @click="onRemoveItem(index)" v-if="items.length > 1">
                <i class="ico ico-trash"></i>
                <span class="cart-grouped-action-label">{{ Translator('front.cart.grouped.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
        <button type="button" class="cart-grouped-button" @click="onAddItem()" v-if="items.length < 20" :disabled="this.formV$.$invalid">
          {{ Translator('front.cart.grouped.add_new') }}
        </button>

        <div class="cart-grouped-footer">
          <p class="form-error cart-grouped-error" v-if="errorMessage">{{ errorMessage }}</p>
          <button type="submit" class="cart-grouped-submit" :disabled="this.formV$.$invalid" :class="{'is-loading': isSubmit}">{{ Translator('front.cart.grouped.submit') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import * as validators from '@vuelidate/validators';
import { helpers } from '@vuelidate/validators'

import GamesService from '@/services/Games';
import ModalService from '@/services/Modal';
import OrdersService from '@/services/Orders';
import AppControlService from '@/services/AppControl';
import CartGroupedItem from '@/components/CartGroupedItem';

export default {
  name: 'cart-grouped',
  components: {
    CartGroupedItem
  },
  data () {
    return {
      errorMessage: null,
      loadingMain: true,
      games: null,
      isSubmit: false,
      onScroll: null,
      isShowInstructions: false,
      items: []
    }
  },
  validations () {
    return {
      items: {
        required: validators.required,
        $each: helpers.forEach({
          serviceType: { required: validators.required },
          game: { required: validators.required },
          language: { required: validators.required },
          currentGame: { required: validators.required },
          extension: {
            requiredIf: validators.requiredIf((value, model) => !model.extensionCode )
          },
          extensionCode: {
            requiredIf: validators.requiredIf((value, model) => !model.extension )
          },
          customExtensionNumber: {},
          value: { required: validators.required },
          options: {}
        })
      }
    }
  },
  created() {},
  mounted() {
    this.$refs.closeBtn.focus();
    GamesService.getAll().then( games => {
      this.games = games;
      this.loadingMain = false;
      this.onAddItem();
    });
  },
  setup: () => ({
    formV$: useVuelidate()
  }),
  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this.isSubmit) return;
      this.formV$.$validate();
      if( !this.formV$.$invalid ) {
        this.isSubmit = true;
        const items = [];
        this.formV$.items.$model.forEach( datas => {
          const item = {
            quantity: 1,
            variant: datas.currentGame.productVariant ? datas.currentGame.productVariant['@id'] : null,
            cardOrderItem: {
              value: datas.value * 100,
              language: datas.language,
              serviceType: datas.serviceType,
            }
          }
          if( datas.insurance ) item.cardOrderItem.insurance = true;
          if( datas.customExtensionNumber ) item.cardOrderItem.customExtensionNumber = datas.customExtensionNumber;
          if( datas.extension ) item.cardOrderItem.extension = datas.extension;
          if( datas.extensionCode ) item.cardOrderItem.extensionCode = datas.extensionCode;
          if( datas.options && datas.options.length > 0 ) item.options = [...datas.options];
          items.push( item );
        })
        OrdersService.addGroupedItem({ items }).then( () => {
          OrdersService.get().then( () => {
            AppControlService.closeGroupedCard();
            this.isSubmit = false;
          })
        }).catch((err) => {
          console.error(err);
          this.isSubmit = false;
          if(err.response && err.response.data && err.response.data['hydra:description']) this._setErrors(err.response.data['hydra:description'])
        });
      }
    },

    onAddItem( orignalItem = null ) {
      if( !orignalItem && this.items.length > 0) {
        orignalItem = {
          ...this.items[ this.items.length - 1 ],
          customExtensionNumber: null,
          value: '',
          insurance: false,
          options: [],
        }
      }
      const item = {
        keyIndex: Math.random().toString(36).substring(2,7),
        serviceType: orignalItem ? orignalItem.serviceType : 'certification',
        game: orignalItem ? orignalItem.game : this.games[0]['@id'],
        currentGame: orignalItem ? orignalItem.currentGame : null,
        language: orignalItem ? orignalItem.language : null,
        extension: orignalItem ? orignalItem.extension : null,
        extensionCode: orignalItem ? orignalItem.extensionCode : null,
        customExtensionNumber: orignalItem ? orignalItem.customExtensionNumber : null,
        value: orignalItem ? orignalItem.value : null,
        insurance: orignalItem ? orignalItem.insurance : false,
        options: orignalItem ? orignalItem.options : []
      };
      this.items.push(item);
    },

    onDupplicateItem( index ) {
      this.onAddItem( this.items[index] );
    },

    onRemoveItem( index ) {
      ModalService.open({
        content: window.Translator.trans('front.cart.grouped.delete_confirm')
      }).then( () => {
        this.items.splice( index, 1);
      });
    },

    onClose() {
      AppControlService.closeGroupedCard();
    },

    isValidItem( item ) {
      return item.serviceType && item.game && item.language && item.value && ( item.extension || item.extensionCode );
    },

    _setErrors( error ) {
      this.errorMessage = error;
      clearTimeout(this._timeoutError);
      this._timeoutError = setTimeout(() => {
        this.errorMessage = null;
      }, 3000);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss">
.cart-grouped {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 90%;
  background-color: $white;
  top: 0;
  z-index: 3;
  min-width: rem(320);
  @include desktop {
    min-width: rem(1024);
  }
  &.is-loading {
    .cart-form {
      @include loader;
      min-height: rem(400);
      & > * {
        display: none;
      }
    }
  }
  .scroll-container {
    -webkit-overflow-scrolling: touch;
  }
  .cart-grouped-loader {
    width: 100%;
    min-height: rem(80);
    @include loader( $color-main );
  }
  .scroll-container,
  .ps {
    position: relative;
    overflow: auto;
    height: 100%;
    padding: rem(35) rem(10) rem(300);
    @include phablet {
      padding-left: rem(20);
      padding-right: rem(20);
    }
    @include tablet {
      padding: rem(35) rem(30) rem(300);
    }
    @include desktop {
      padding: rem(55) rem(30) rem(300);
    }
    @include desktop-xl {
      padding: rem(55) rem(30) rem(300);
    }
  }
  .cart-grouped-item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: rem(3);
    padding-top: rem(10);
    padding-bottom: rem(10);
    @include tablet-max {
      flex-direction: column;
      padding: 0 rem(20);
      padding-right: 0;
    }
    @include desktop {
      &:not(:first-child) {
        border-top: rem(1) solid $grey;
      }
    }
  }
  .cart-grouped-list {
    margin-bottom: rem(15);
    @include desktop {
      margin-bottom: rem(30);
    }
  }
  .cart-grouped-item-actions {
    display: flex;
    align-items: center;
    gap: rem(3);
    flex-shrink: 0;
    @include tablet-max {
      margin-bottom: rem(5);
      width: 100%;
      &::before {
        content: '';
        display: block;
        width: 100%;
        height: rem(1);
        background-color: $grey;
      }
    }
    @include desktop {
      width: rem(60);
      margin-right: 0;
      margin-left: auto;
    }
  }
  .std-form {
    position: relative;
    box-shadow: none;
    padding: 0;
    border-radius: 0;
    margin-left: 0;
    margin-right: 0;
  }
  .cart-grouped-close {
    @include resetBtn;
    position: absolute;
    top: rem(30);
    right: rem(30);
    color: $blue-udark;
    border: rem(2) solid $blue-udark;
    transition: color $transition-out-hover, border-color $transition-out-hover;
    border-radius: 100%;
    width: rem(30);
    height: rem(30);
    line-height: rem(28);
    text-align: center;
    z-index: 2;
    &:hover, &:focus {
      color: $color-second;
      border-color: $color-second;
      transition: color $transition-in-hover, border-color $transition-in-hover;
    }
  }
  .cart-grouped-error {
    @include visible;
    display: block;
  }
  .cart-grouped-footer {
    display: flex;
    align-items: center;
    gap: rem(10);
    margin-top: rem(50);
    &::before,
    &::after {
      content: '';
      display: block;
      height: rem(1);
      width: 100%;
      background-color: $grey;
    }
  }
  .cart-grouped-submit {
    @include cta($white, $blue) {
      margin-left: auto;
      margin-right: auto;
      flex-shrink: 0;
      @include tablet-max {
        width: auto;
      }
    }
  }
  .cart-grouped-title {
    @include title(3);
    margin-bottom: rem(30);
  }
  .cart-grouped-subtitle {
    @include title(4);
    margin-bottom: rem(20);
  }
  .cart-grouped-action {
    @include resetBtn;
    position: relative;
    width: rem(40);
    height: rem(40);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: $black;
    transition: color $transition-out-hover;
    font-size: rem(26);
    @include desktop {
      font-size: rem(20);
      width: rem(25);
      height: rem(25);
    }
    &:hover, &:focus-visible {
      color: $color-second;
      transition: color $transition-in-hover;
      .cart-grouped-action-label {
        opacity: 1;
        transition: opacity $transition-in-hover;
      }
    }
  }
  .cart-grouped-action-label {
    position: absolute;
    left: 50%;
    top: rem(-3);
    z-index: 20;
    padding: rem(2) rem(5);
    transform: translate(-50%, -100%);
    background: rgba($black, .7);
    color: $white;
    font-size: rem(8);
    opacity: 0;
    transition: opacity $transition-out-hover;
    pointer-events: none;
    text-align: center;
    white-space: nowrap;
    display: inline-block;
    border-radius: rem(2);
    @include tablet-max {
      display: none;
    }
  }
  .cart-instructions {
    border-radius: rem(8);
    background-color: #E7F3F7;
    margin-bottom: rem(20);
    padding: rem(10) rem(10) rem(7);
    @include tablet {
      padding: rem(15) rem(25);
    }
    &.is-open {
      .cart-instructions-toggle {
        .ico {
          transform: rotate(0);
        }
      }
    }
    .cart-instructions-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .cart-instructions-title {
      @include title(4);
      margin-bottom: 0;
      @include mobile {
        display: none;
      }
    }
    .cart-instructions-content {
      font-size: rem(12);
      color: $blue-mdark;
      margin-top: rem(20);
    }
    .cart-instructions-description {
      margin-bottom: rem(20);
    }
    .cart-instructions-legend {
      ::v-deep {
        ul {
          @include resetList;
        }
        li {
          padding-top: rem(3);
          padding-bottom: rem(3);
        }
        img {
          vertical-align: middle;
          width: rem(15);
          height: rem(15);
          object-fit: contain;
          margin-right: rem(10);
        }
      }
    }
    .cart-instructions-subtitle {
      font-weight: bold;
      margin-bottom: rem(15);
      font-size: rem(12);
    }
    .cart-instructions-toggle {
      @include resetBtn;
      font-size: rem(14);
      font-weight: bold;
      color: $blue-mdark;
      .ico {
        display: inline-block;
        vertical-align: middle;
        font-size: rem(20);
        margin-left: rem(10);
        transform: rotate(-180deg);
        transition: transform $transition-out-hover;
      }
    }

  }
  .cart-grouped-button {
    @include cta;
    @include tablet-max {
      width: auto;
      margin: rem(20) rem(30) 0;
    }
  }
}
</style>
